import React from "react";
import { withLDProvider } from "launchdarkly-react-client-sdk";
import AppContent from "./AppContent";
import { AppStoreProvider } from "./store";
import { toast, Slide } from "react-toastify";
import { ldProviderConfig } from "../helpers/launchDarklyHelpers";
import TealiumHandler from "./TealiumHandler";

toast.configure({
  transition: Slide,
});

export const App: React.FunctionComponent = () => {
  return (
    <AppStoreProvider>
      <TealiumHandler>
        <AppContent />
      </TealiumHandler>
    </AppStoreProvider>
  );
};

export default withLDProvider(ldProviderConfig)(App);
